(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farmlands-collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-read-more')) {
    class FlReadMore extends HTMLElement {
      #resizeObserver = null;

      connectedCallback() {
        this.description = this.querySelector('[data-description]');
        this.toggle = this.querySelector('[data-toggle]');
        if (!this.description || !this.toggle) return;

        this.toggle.addEventListener('click', this.#handleClick);
        this.#resizeObserver = new ResizeObserver(() => this.#updateVisibility());
        this.#resizeObserver.observe(this.description);
        this.#updateVisibility();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.#handleClick);
        this.#resizeObserver?.disconnect();
      }

      #updateVisibility() {
        const isExpanded = this.description.classList.contains('is-expanded');
        const isClamped = this.description.scrollHeight > this.description.clientHeight + 1;
        this.toggle.hidden = !(isExpanded || isClamped);
      }

      #handleClick = () => {
        const isExpanded = this.description.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', String(isExpanded));
        const label = this.toggle.querySelector('[data-toggle-label]');
        if (label) {
          label.textContent = isExpanded ? this.toggle.dataset.labelLess : this.toggle.dataset.labelMore;
        }
      };
    }

    customElements.define('fl-read-more', FlReadMore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farmlands-subcollection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-subcollections-slider')) {
    class FlSubcollectionsSlider extends HTMLElement {
      #list = null;
      #prev = null;
      #next = null;
      #resizeObserver = null;
      #frame = 0;

      connectedCallback() {
        this.#list = this.querySelector('[data-slider-list]');
        if (!this.#list) return;

        this.#prev = this.querySelector('[data-slider-prev]');
        this.#next = this.querySelector('[data-slider-next]');

        this.#list.addEventListener('scroll', this.#handleScroll, { passive: true });
        this.#prev?.addEventListener('click', this.#handlePrev);
        this.#next?.addEventListener('click', this.#handleNext);

        this.#resizeObserver = new ResizeObserver(() => this.#update());
        this.#resizeObserver.observe(this.#list);
        this.#update();
      }

      disconnectedCallback() {
        this.#list?.removeEventListener('scroll', this.#handleScroll);
        this.#prev?.removeEventListener('click', this.#handlePrev);
        this.#next?.removeEventListener('click', this.#handleNext);
        this.#resizeObserver?.disconnect();
        cancelAnimationFrame(this.#frame);
        this.#frame = 0;
      }

      /* Shows the arrows once the tiles overflow, and disables each at its end of the scroll. */
      #update() {
        const maxScroll = this.#list.scrollWidth - this.#list.clientWidth;
        this.toggleAttribute('data-scrollable', maxScroll > 1);
        if (this.#prev) this.#prev.disabled = this.#list.scrollLeft <= 1;
        if (this.#next) this.#next.disabled = this.#list.scrollLeft >= maxScroll - 1;
      }

      #scrollByScreen(direction) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#list.scrollBy({ left: direction * this.#list.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      #handleScroll = () => {
        if (this.#frame) return;
        this.#frame = requestAnimationFrame(() => {
          this.#frame = 0;
          this.#update();
        });
      };

      #handlePrev = () => this.#scrollByScreen(-1);

      #handleNext = () => this.#scrollByScreen(1);
    }

    customElements.define('fl-subcollections-slider', FlSubcollectionsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
